export default "__VITE_ASSET__9Am9RO0H__"